var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"section-title-card"},[_c('div',{staticClass:"st-title"},[_vm._v(_vm._s(_vm.title))]),(_vm.desc)?_c('div',{staticClass:"st-desc"},[_vm._v(_vm._s(_vm.desc))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }